// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { DiagnosesicherheitEntity } from '../../../entities/mdqx/diagnosesicherheit.entity';
import {
    MutationChangeDiagnosesicherheitArgs,
    MutationCreateDiagnosesicherheitArgs,
    MutationDeleteDiagnosesicherheitArgs,
} from '../../../mdqx-graphql-types';

export enum DiagnosesicherheitActionTypes {
    GetDiagnosesicherheitenRequest = '[Diagnosesicherheiten] Get Request',
    GetDiagnosesicherheitenResponse = '[Diagnosesicherheiten] Get Response',
    PostDiagnosesicherheitRequest = '[Diagnosesicherheit] Post Request',
    PostDiagnosesicherheitResponse = '[Diagnosesicherheit] Post Response',
    PatchDiagnosesicherheitRequest = '[Diagnosesicherheit] Patch Request',
    PatchDiagnosesicherheitResponse = '[Diagnosesicherheit] Patch Response',
    DeleteDiagnosesicherheitRequest = '[Diagnosesicherheit] Delete Request',
    DeleteDiagnosesicherheitResponse = '[Diagnosesicherheit] Delete Response',
}

export class GetDiagnosesicherheitenRequest implements Action {
    readonly type = DiagnosesicherheitActionTypes.GetDiagnosesicherheitenRequest;
}

export class GetDiagnosesicherheitenResponse implements Action {
    readonly type = DiagnosesicherheitActionTypes.GetDiagnosesicherheitenResponse;
    constructor(public Payload: DiagnosesicherheitEntity[]) {}
}

export class PostDiagnosesicherheitRequest implements Action {
    readonly type = DiagnosesicherheitActionTypes.PostDiagnosesicherheitRequest;
    constructor(public Payload: MutationCreateDiagnosesicherheitArgs) {}
}

export class PostDiagnosesicherheitResponse implements Action {
    readonly type = DiagnosesicherheitActionTypes.PostDiagnosesicherheitResponse;
    constructor(public Payload: DiagnosesicherheitEntity) {}
}

export class PatchDiagnosesicherheitRequest implements Action {
    readonly type = DiagnosesicherheitActionTypes.PatchDiagnosesicherheitRequest;
    constructor(public Payload: MutationChangeDiagnosesicherheitArgs) {}
}

export class PatchDiagnosesicherheitResponse implements Action {
    readonly type = DiagnosesicherheitActionTypes.PatchDiagnosesicherheitResponse;
    constructor(public Payload: DiagnosesicherheitEntity) {}
}

export class DeleteDiagnosesicherheitRequest implements Action {
    readonly type = DiagnosesicherheitActionTypes.DeleteDiagnosesicherheitRequest;
    constructor(public Payload: MutationDeleteDiagnosesicherheitArgs) {}
}

export class DeleteDiagnosesicherheitResponse implements Action {
    readonly type = DiagnosesicherheitActionTypes.DeleteDiagnosesicherheitResponse;
    constructor(public Payload: number) {}
}

export type DiagnosesicherheitActions =
    | GetDiagnosesicherheitenRequest
    | GetDiagnosesicherheitenResponse
    | PostDiagnosesicherheitRequest
    | PostDiagnosesicherheitResponse
    | PatchDiagnosesicherheitRequest
    | PatchDiagnosesicherheitResponse
    | DeleteDiagnosesicherheitRequest
    | DeleteDiagnosesicherheitResponse;
